import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const CommissionEditDialog = ({ commission, onOpenChange, onSave, saving }) => {
  const [f, setF] = useState({ amount: "", status: "pending", period: "", note: "" });
  useEffect(() => {
    if (commission) { setF({ amount: String(commission.amount ?? ""), status: commission.status || "pending", period: commission.period || "", note: commission.note || "" }); }
  }, [commission]);
  const amount = parseFloat(String(f.amount).replace(",", "."));
  const valid = !Number.isNaN(amount) && amount >= 0 && /^\d{4}-(0[1-9]|1[0-2])$/.test(f.period);
  return (
    <Dialog open={!!commission} onOpenChange={onOpenChange}>
      <DialogContent data-testid="commission-edit-dialog">
        <DialogHeader><DialogTitle>Modifica provvigione</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3 text-sm">
          <div><Label className="text-xs">Importo (€)</Label><Input value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} inputMode="decimal" data-testid="commission-edit-amount" /></div>
          <div><Label className="text-xs">Mese di competenza</Label><Input type="month" value={f.period} onChange={(e) => setF({ ...f, period: e.target.value })} data-testid="commission-edit-period" /></div>
          <div className="col-span-2"><Label className="text-xs">Stato</Label>
            <Select value={f.status} onValueChange={(v) => setF({ ...f, status: v })}>
              <SelectTrigger data-testid="commission-edit-status"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="pending">Da pagare</SelectItem><SelectItem value="paid">Pagata</SelectItem></SelectContent>
            </Select>
            {f.status === "paid" && <p className="text-xs text-amber-700 mt-1">Una volta pagata non si potrà più modificare né cancellare.</p>}
          </div>
          <div className="col-span-2"><Label className="text-xs">Nota</Label><Textarea value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} rows={3} data-testid="commission-edit-note" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>
          <Button disabled={!valid || saving} onClick={() => onSave({ ...f, amount })} className="bg-[#B84A2B] hover:bg-[#983C21] text-white" data-testid="commission-edit-save">Salva</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
